var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusFour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_10",
    "data-name": "Exclusion 10",
    d: "M1430-705h-36v-3h6a3,3,0,0,1-3-3v-15a2.982,2.982,0,0,1,.876-2.124A2.984,2.984,0,0,1,1400-729h24a3,3,0,0,1,3,3l-.015,15a3,3,0,0,1-2.985,3h6v3Zm-13.811-10.154V-713h1.975v-2.154h1.128v-1.593h-1.128v-6.206h-2l-4.15,6.555.089,1.244Zm-9.325-1.633V-714h1.88v-2.789h2.468v-1.785h-2.468v-2.672h-1.88v2.672h-2.474v1.785Zm9.325.04h-2.2l2.071-3.288.13-.226v3.513Z",
    transform: "translate(-1394 729)",
    fill: "#527991"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusFour);
export default __webpack_public_path__ + "static/media/plusFour.bea075be.svg";
export { ForwardRef as ReactComponent };